export const DATA_POINT_DURATION_H = 0.25;
export const NR_OF_VALUES = (365 * 24) / DATA_POINT_DURATION_H;
